import {view} from '@sail/ui';
import {createViewConfig} from '@sail/engine';
import type {View} from '@sail/engine';
import {styles} from 'mkt-ssr/components/sail/CustomerLogoGrid/CustomerLogoGridStyles';

export type CustomerLogoGridProps = View.IntrinsicElement<
  'div',
  {
    /**
     * The logos to be displayed inside of the CustomerLogoGrid
     */
    children: React.ReactNode;
    /**
     * The logos to be displayed inside of the CustomerLogoGrid
     */
    orientation: 'horizontal' | 'vertical';
  }
>;

export const CustomerLogoGridConfig = createViewConfig({
  props: {} as CustomerLogoGridProps,
  name: 'CustomerLogoGrid',
  defaults: {
    orientation: 'horizontal',
  },
});

/**
 * Displays customer logos in a grid
 */
export const CustomerLogoGrid = CustomerLogoGridConfig.createView(
  ({children, ...props}) => {
    return (
      <view.div {...props} uses={[styles.container]}>
        {children}
      </view.div>
    );
  },
  {
    variants: {
      orientation: {
        horizontal: styles.horizontalLayout,
        vertical: styles.verticalLayout,
      },
    },
  },
);
